import { MDBBtn, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import React from 'react';
import { Link } from 'react-router-dom';

function NoRequests () {
  return (

  <MDBContainer className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center" >
  
    <MDBRow>
      <div className="col-12">
        <section className="my-5 text-center">
        {/* <h1 className="display-1">404</h1> */}
          <h2 className="display-1">NO REQUESTS YET</h2>

          <h4 className="mb-4">Please start creating </h4>

          <p className="mb-0">
            Try creaing inventory first if there is none
          </p>
          <p className="mb-4">
            Go back, and start creating requests
          </p>
          <Link to="/home">
            <MDBBtn>Create Request(s)</MDBBtn>
          </Link>
        </section>
      </div>
    </MDBRow>
  </MDBContainer>

);
}
export default NoRequests;
